import { render } from "./FlashMessage.vue?vue&type=template&id=4cdb396f&scoped=true"
import script from "./FlashMessage.vue?vue&type=script&lang=js"
export * from "./FlashMessage.vue?vue&type=script&lang=js"

import "./FlashMessage.vue?vue&type=style&index=0&id=4cdb396f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cdb396f"]])

export default __exports__